import ModuleDetailHeader from './ModuleDetailHeader.vue'

export default ModuleDetailHeader
export { ModuleDetailHeader }